var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "image-upload-multiple",
      staticStyle: { "padding-top": "10px" },
    },
    [
      _c(
        "el-upload",
        {
          ref: "uploader",
          attrs: {
            "auto-upload": _vm.autoUpload,
            disabled: _vm.disabled,
            action: _vm.action,
            name: _vm.name,
            data: _vm.data,
            "http-request": _vm.request,
            "file-list": _vm.defaultFileList,
            "show-file-list": false,
            accept: _vm.accept,
            multiple: false,
            "before-upload": _vm.before,
            "on-remove": _vm.remove,
            "on-success": _vm.success,
            "on-error": _vm.error,
            "on-preview": _vm.handlePreview,
            "on-exceed": _vm.handleExceed,
          },
          scopedSlots: _vm._u([
            {
              key: "tip",
              fn: function () {
                return [
                  _vm.tip
                    ? _c("div", { staticClass: "el-upload__tip" }, [
                        _vm._v(_vm._s(_vm.tip)),
                      ])
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._t("default", function () {
            return [
              _vm.defaultFileList.length > 0
                ? _c(
                    "div",
                    { staticClass: "image-upload-list-item" },
                    [
                      _vm.disabled
                        ? _c("el-image", {
                            staticClass:
                              "el-upload-list__item-thumbnail upload-image-size",
                            attrs: {
                              slot: "reference",
                              src: _vm.defaultFileList[0].url,
                              fit: "cover",
                              "preview-src-list": _vm.preview,
                              "initial-index": _vm.preview.findIndex(function (
                                n
                              ) {
                                return n == _vm.defaultFileList[0].url
                              }),
                              "hide-on-click-modal": "",
                              "append-to-body": "",
                              "z-index": 9999,
                            },
                            slot: "reference",
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "placeholder",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "image-upload-multiple-image-slot",
                                        },
                                        [_vm._v(" Loading... ")]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              1269552939
                            ),
                          })
                        : _c("el-image", {
                            staticClass: "upload-image-size",
                            attrs: {
                              src: _vm.defaultFileList[0].url,
                              fit: "cover",
                            },
                          }),
                      !_vm.disabled
                        ? _c(
                            "div",
                            { staticClass: "image-upload__item-actions" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "del",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.handleRemove()
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "el-icon-delete" })]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _c("div", { staticClass: "el-upload--picture-card " }, [
                    _c("i", {
                      staticClass: "el-icon-plus avatar-uploader-icon",
                    }),
                  ]),
            ]
          }),
        ],
        2
      ),
      _c(
        "span",
        { staticStyle: { display: "none !important" } },
        [
          _c("el-input", {
            model: {
              value: _vm.value,
              callback: function ($$v) {
                _vm.value = $$v
              },
              expression: "value",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }